"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasUsTransactionSanctionScreening = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.HasUsTransactionSanctionScreening = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.has_us_transaction_sanction_screening.label',
    fallbackLabel: 'Please confirm that you have implemented 1. Transaction controls designed to comply with U.S. sanctions programs (blocking or freezing the prohibited transactions), 2. Internal training and awareness programs about U.S. sanctions regulations and compliance and that you maintain according to detection, investigation, assessment and escalation processes.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.will_operate_in_us', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.Boolean,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.will_operate_in_us === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.will_operate_in_us === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
